const latRad = (lat: number): number => {
  const sin = Math.sin((lat * Math.PI) / 180);
  const radX2 = Math.log((1 + sin) / (1 - sin)) / 2;
  return Math.max(Math.min(radX2, Math.PI), -Math.PI) / 2;
};

const getZoom = (lat1: number, lng1: number, lat2: number, lng2: number): number => {
  const latDif = Math.abs(latRad(lat1) - latRad(lat2));
  const lngDif = Math.abs(lng1 - lng2);

  const latFrac = latDif / Math.PI;
  const lngFrac = lngDif / 360;

  const lngZoom = Math.log(1 / latFrac) / Math.log(2);
  const latZoom = Math.log(1 / lngFrac) / Math.log(2);

  return Math.min(lngZoom, latZoom);
};

export { latRad, getZoom };
